import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { MdArrowDropDown, MdClose } from 'react-icons/md'
import Flex from '../Flex/Flex'
import Text from '../Text/Text'
import styles from './selectMultField.module.scss'

const handleChange = (event, name, selecteds, setSelect, setFieldValue) => {
  const current = event?.target
  const currentValue = current?.value
  const currentName = current.selectedOptions[0].getAttribute('name')

  if (currentValue === 0) return null

  const found = selecteds.find((item) => item.id === currentValue)

  if (found) return null

  const newSelecteds = [...selecteds]

  newSelecteds.push({
    name: currentName,
    id: currentValue
  })

  setSelect(newSelecteds)

  const newDatas = newSelecteds.map((item) => item.id)

  return setFieldValue(name, newDatas)
}

const handleRemove = (data, name, selecteds, setSelect, setFieldValue) => {
  const newSelecteds = [...selecteds]

  const foundIndex = newSelecteds.findIndex((item) => item.id === data.id)

  if (foundIndex < 0) return null

  newSelecteds.splice(foundIndex, 1)

  setSelect(newSelecteds)

  const newDatas = newSelecteds.map((item) => item.id)

  return setFieldValue(name, newDatas)
}

export const getOptionByValue = (values = [], options = []) => {
  return values.map((value) => options.find((option) => option.id === value))
}

const SelectMultField = (props) => {
  const {
    field: { name, id, value } = {},
    form: { setFieldValue } = {},
    options = [],
    placeholder
  } = props

  const [selecteds, setSelect] = useState(value)

  useEffect(() => {
    if (value.length === 0) {
      return setSelect([])
    }

    return setSelect(getOptionByValue(value, options))
  }, [value])

  const optionsComponent = options.map((option) => (
    <option key={option.id} name={option.name} value={option.id}>
      {option.name}
    </option>
  ))

  const selectedComponent = selecteds.map((selected) => (
    <div key={selected.id} className={styles.filterSelected}>
      <Text value={selected.name} color="white" font="custom" size="xxs" />

      <MdClose
        color="white"
        onClick={() => {
          return handleRemove(
            selected,
            name,
            selecteds,
            setSelect,
            setFieldValue
          )
        }}
      />
    </div>
  ))

  return (
    <>
      <div className={styles.selectField}>
        <select
          id={id}
          name={name}
          onChange={(event) => {
            return handleChange(
              event,
              name,
              selecteds,
              setSelect,
              setFieldValue
            )
          }}
        >
          <option value={undefined}>{placeholder}</option>

          {optionsComponent}
        </select>
        <MdArrowDropDown color="#737373" />
      </div>

      <Flex margin="10px 0px" wrap="wrap">
        {selectedComponent}
      </Flex>
    </>
  )
}

SelectMultField.defaultProps = {
  field: undefined,
  form: undefined,
  options: [],
  placeholder: ''
}

SelectMultField.propTypes = {
  field: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    )
  }),
  form: PropTypes.shape({
    touched: PropTypes.shape({}),
    errors: PropTypes.shape({}),
    setFieldValue: PropTypes.func
  }),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string
    })
  ),
  placeholder: PropTypes.string
}

export default SelectMultField
